import type { ToolbarOptions } from '@vue-pdf-viewer/viewer';

export const defaultToolbarOptions: Partial<ToolbarOptions> = {
  printable: false,
  downloadable: false,
  sidebarEnable: false,
  newFileOpenable: false,
  themeSwitchable: false,
  pageViewSwitchable: false,
  scrollingSwitchable: false,
  docPropertiesEnabled: false,
  pointerSwitchable: false,
  rotatable: false,
  thumbnailViewable: false,
  fullscreen: false,
  jumpNavigatable: false,
};
